{
  "welcome": {
    "title": "Bienvenue dans My City",
    "tagline": "Signalez. Suivez. Améliorez votre ville.",
    "cta": {
      "google": "Continuer avec Google",
      "identityKind": "Se connecter avec",
      "phone": "Téléphone",
      "email": "E-mail",
      "continue": "Continuer",
      "or": "ou"
    }
  },
  "otp": {
    "title": "Entrez le code",
    "subtitle": "Nous avons envoyé un code à 6 chiffres à {{destination}}.",
    "input": "Code de vérification",
    "verify": "Vérifier",
    "resendIn": "Renvoyer dans {{seconds}}s",
    "resend": "Renvoyer le code",
    "changeIdentity": "Utiliser un autre téléphone ou e-mail"
  },
  "auth": {
    "errors": {
      "invalidIdentity": "Entrez un téléphone (+14165551234) ou une adresse e-mail",
      "sendFailed": "Impossible d'envoyer le code. Réessayez dans un instant.",
      "invalidCode": "Ce code ne correspond pas. Réessayez.",
      "expired": "Code expiré. Demandez-en un nouveau.",
      "lockout": "Trop de tentatives. Demandez un nouveau code.",
      "accountConflict": "Une autre connexion à ce compte est en cours. Patientez un instant, puis réessayez.",
      "channelUnavailable": "Cette méthode de connexion est indisponible pour le moment. Essayez une autre méthode.",
      "unexpected": "Une erreur s'est produite. Réessayez.",
      "invalidIdentityPhoneOnly": "Saisissez un numéro de téléphone (+14165551234)",
      "accountDeactivated": "Ce compte a été désactivé. Contactez le soutien si vous pensez qu'il s'agit d'une erreur."
    },
    "signOut": "Déconnexion"
  },
  "home": {
    "header": "MY CITY",
    "anonymous": "citoyen·ne",
    "newsTitle": "Actualités municipales",
    "eventsAnnouncementsTitle": "Événements et avis",
    "projectsTitle": "Projets municipaux",
    "pollsTitle": "Donnez votre avis",
    "viewAll": "Tout voir",
    "weather": {
      "currentLocation": "Position actuelle",
      "temperature": "{{value}} °C"
    },
    "banner": {
      "title": "En vedette",
      "dot": "Aller à la bannière {{index}}"
    },
    "highlights": {
      "title": "À la une",
      "mine": {
        "problem": "Mon signalement",
        "request": "Ma demande"
      },
      "dot": "Aller à la diapositive {{index}}"
    },
    "poll": {
      "title": "Donnez votre avis",
      "submit": "Envoyer",
      "voted": "Merci d'avoir voté !",
      "changeVote": "Modifier mon vote",
      "endsAt": "Le vote se termine {{when}}",
      "resultStat": "{{pct}} % ({{count}})",
      "voteFailed": "Impossible d'enregistrer votre vote. Veuillez réessayer.",
      "totalVotes": "{{count}} votes à ce jour"
    },
    "newsDot": "Aller à l'actualité {{index}}",
    "eventsAnnouncementsDot": "Aller à l'avis ou à l'événement {{index}}",
    "projectsDot": "Aller au projet {{index}}",
    "pollsDot": "Aller au sondage {{index}}",
    "sectionFailed": "Cette section n’a pas pu être chargée."
  },
  "reportStatus": {
    "pending": "Soumis",
    "triaged": "Soumis",
    "assigned": "Assigné",
    "accepted": "Prise en charge",
    "in_progress": "En cours",
    "resolved": "Résolu",
    "closed": "Fermé",
    "reopened": "Rouvert",
    "cancelled": "Rejeté"
  },
  "reportKind": {
    "problem": "Problème",
    "request": "Demande"
  },
  "report": {
    "title": {
      "problem": "Nouveau signalement",
      "request": "Nouvelle demande"
    },
    "city": "Ville",
    "kind": {
      "problem": "Signaler un problème",
      "problemHint": "Quelque chose est cassé, dangereux ou à réparer.",
      "request": "Soumettre une demande",
      "requestHint": "Demandez un service ou une amélioration à la ville."
    },
    "description": {
      "problem": "Que souhaitez-vous signaler ?",
      "request": "Que demandez-vous à la ville ?"
    },
    "descriptionPlaceholder": {
      "problem": "Nid-de-poule côté sud de la rue Main, 50 m à l’est de Brant…",
      "request": "Une nouvelle poubelle à l’entrée du parc, ou un arbre à élaguer…"
    },
    "location": "Emplacement",
    "locationHint": "Faites glisser la carte pour situer l'endroit, ou touchez le bouton de localisation.",
    "photos": "Photos",
    "photo": {
      "camera": "Appareil photo",
      "gallery": "Galerie",
      "remove": "Retirer la photo",
      "blockedByVoice": "Retirez le message vocal pour ajouter une photo.",
      "maxReached": "Nombre maximal de photos atteint ({{max}}).",
      "someDropped": "Certaines photos n'ont pas été ajoutées — la limite est de {{max}}.",
      "preparing": "Préparation de la photo…",
      "previewUnavailable": "Aperçu indisponible",
      "unreadable": "Cette photo n'a pas pu être lue. Reprenez-la, ou choisissez un JPEG ou un PNG.",
      "unreadable_other": "{{count}} de ces photos n'ont pas pu être lues. Reprenez-les, ou choisissez des fichiers JPEG ou PNG."
    },
    "useMyLocation": "Utiliser ma position actuelle",
    "submit": {
      "problem": "Envoyer le signalement",
      "request": "Envoyer la demande"
    },
    "submitting": "Envoi en cours…",
    "success": {
      "title": {
        "problem": "Signalement envoyé",
        "request": "Demande envoyée"
      },
      "body": {
        "problem": "Votre signalement a été enregistré. Voici votre code de suivi.",
        "request": "Votre demande a été enregistrée. Voici votre code de suivi."
      },
      "trackingCode": "Code de suivi",
      "viewReports": "Voir mes signalements",
      "fileAnother": "Envoyer autre chose",
      "attachmentsFailed": "{{count}} pièce jointe n'a pas pu être téléversée — le reste a bien été envoyé.",
      "attachmentsFailed_other": "{{count}} pièces jointes n'ont pas pu être téléversées — le reste a bien été envoyé.",
      "retryAttachments": "Réessayer l'envoi",
      "retrying": "Envoi…",
      "attachmentsRecovered": "Tout a bien été téléversé.",
      "alreadyReported": "Quelqu’un l’a signalé avant vous, sous {{code}}. Le vôtre est rattaché à la même intervention — vous recevrez les mêmes mises à jour."
    },
    "errors": {
      "noCity": "Veuillez sélectionner une ville.",
      "cityLoadFailed": "Impossible de charger la liste des villes.",
      "noCityAvailable": "Le signalement n’est pas encore disponible — aucune ville n’est active.",
      "tooShort": "Ajoutez un peu plus de détails (4 caractères minimum).",
      "needDetailOrPhoto": "Ajoutez une photo ou une courte description (4 caractères minimum).",
      "requestMediaLimit": "Une demande ne peut inclure qu'une seule pièce jointe. Gardez une photo ou un message vocal et retirez le reste.",
      "submitFailed": "Impossible de l'envoyer. Réessayez dans un instant.",
      "geoDenied": "L'autorisation de lire votre position a été refusée.",
      "noSeverity": "Veuillez choisir un niveau de gravité.",
      "locationFailed": "Impossible d'obtenir votre position. Faites glisser l'épingle au bon endroit.",
      "locationUnconfirmed": "Indiquez l’endroit avant de continuer : utilisez le bouton de localisation, déplacez le repère ou saisissez une adresse.",
      "outsideServiceArea": "Cet endroit est hors de la zone desservie par {{city}}. Déplacez le repère dans la ville, ou changez de ville à l’étape Vérification.",
      "blockedTitle": "Vous ne pouvez pas déposer de nouveaux signalements dans cette ville",
      "blockedReason": "Motif donné par la ville : {{reason}}",
      "blockedUntil": "Cette restriction prend fin le {{date}}. Elle ne vise que cette ville — le reste de votre compte n’est pas touché.",
      "blockedAppeal": "Vous pensez qu’il s’agit d’une erreur ? Contactez l’assistance"
    },
    "wizard": {
      "back": "Retour",
      "next": "Suivant",
      "kindHint": "Que souhaitez-vous envoyer à la ville ?",
      "mediaHint": "Prenez une photo, ajoutez un court message vocal et décrivez votre signalement.",
      "requestMediaHint": "Décrivez votre demande. Vous pouvez joindre au plus un élément — une seule photo ou un seul message vocal.",
      "locationHint": "Votre position est épinglée — faites glisser la carte pour l’ajuster ou saisissez une adresse ci-dessous.",
      "severityHint": "Quelle est la gravité ?",
      "reviewHint": "Vérifiez tout avant d’envoyer.",
      "steps": {
        "kind": "Type",
        "media": "Médias",
        "location": "Emplacement",
        "severity": "Gravité",
        "review": "Résumé"
      },
      "locationUnconfirmed": "Ce repère indique le centre-ville, et non l’endroit que vous signalez. Utilisez le bouton de localisation, déplacez la carte ou saisissez une adresse ci-dessous."
    },
    "voice": {
      "title": "Message vocal (optionnel)",
      "record": "Enregistrer",
      "stop": "Arrêter ({{seconds}}s)",
      "play": "Lire",
      "pause": "Pause",
      "discard": "Supprimer l'enregistrement",
      "hint": "Jusqu'à {{max}} secondes.",
      "unsupported": "L'enregistrement vocal n'est pas pris en charge.",
      "errors": {
        "micDenied": "Accès au microphone refusé.",
        "playFailed": "Impossible de lire l'enregistrement sur cet appareil."
      },
      "blockedByPhoto": "Retirez la photo pour enregistrer un message vocal."
    },
    "charCount": "{{used}}/{{max}}",
    "severity": {
      "low": "Faible",
      "medium": "Moyenne",
      "high": "Élevée"
    },
    "review": {
      "category": "Catégorie (suggérée par l’IA)",
      "categoryAuto": "Automatique — laisser la ville décider",
      "categoryLoading": "Analyse de votre signalement…",
      "aiType": "Classification IA",
      "aiTypeUse": "Utiliser la suggestion de l’IA ({{type}})",
      "aiTypeSelect": "Sélectionnez un type…",
      "aiTypeNoneOfThese": "Aucun de ces types",
      "aiSeverity": "Gravité estimée par l’IA",
      "descriptionLoading": "L’IA rédige une description à partir de votre photo…"
    },
    "addressSearch": {
      "label": "Ou saisissez une adresse",
      "placeholder": "ex. : 120, rue Principale",
      "action": "Rechercher cette adresse",
      "searching": "Recherche de l’adresse…",
      "results": "Touchez la bonne adresse — le repère s’y déplacera :",
      "tooShort": "Saisissez au moins 3 caractères de l’adresse.",
      "noResults": "Aucune adresse ne correspond. Vérifiez l’orthographe ou déplacez plutôt le repère.",
      "degraded": "La recherche d’adresse est indisponible pour le moment — ce n’est pas une faute d’orthographe. Réessayez dans un instant ou déplacez plutôt le repère.",
      "rateLimited": "Trop de recherches d’affilée. Attendez environ une minute, puis réessayez.",
      "failed": "La recherche d’adresse n’a pas abouti. Réessayez ou déplacez plutôt le repère.",
      "movedTo": "Repère déplacé vers {{address}}"
    },
    "descriptionOptional": "Facultatif — votre message vocal le dit"
  },
  "myReports": {
    "title": "Signalements",
    "empty": "Vous n'avez encore envoyé aucun signalement.",
    "fileFirst": "Envoyer mon premier signalement",
    "filedAt": "Envoyé {{when}}",
    "viewToggle": "Affichage",
    "view": {
      "list": "Liste",
      "map": "Carte"
    },
    "filterLabel": "Filtrer les signalements",
    "filterEmpty": "Aucun signalement ne correspond à ce filtre.",
    "filters": {
      "all": "Tous",
      "pending": "Soumis",
      "active": "Actifs",
      "closed": "Fermés et rejetés"
    }
  },
  "reportsMap": {
    "pinLabel": "{{code}} — {{status}}"
  },
  "validation": {
    "title": "Le problème est-il réglé ?",
    "body": "La ville indique que votre signalement est résolu. Confirmez-nous — si ce n'est pas le cas, l'équipe sera renvoyée.",
    "confirm": "Oui, c'est réparé",
    "dispute": "Non, ce n'est pas réglé",
    "disputeTitle": "Qu'est-ce qui ne va pas ?",
    "disputePlaceholder": "Le nid-de-poule est rebouché mais le rapiéçage s'effrite déjà…",
    "disputeSubmit": "Rouvrir le signalement",
    "submitting": "Envoi en cours…",
    "failed": "Impossible d'envoyer votre retour. Réessayez.",
    "ratePrompt": "Comment était le service ? Notez-le pour fermer le signalement.",
    "rateSubmit": "Envoyer la note",
    "starLabel_one": "{{count}} étoile",
    "starLabel_other": "{{count}} étoiles",
    "thanksTitle": "Merci !",
    "thanksBody": "Votre confirmation a fermé le signalement. Votre score citoyen vient d’augmenter.",
    "reopenedTitle": "Signalement rouvert",
    "reopenedBody": "L’équipe est renvoyée sur place. Vous serez averti·e dès que c’est réparé.",
    "evidencePhotos": "Photos justificatives (optionnel)",
    "evidenceVoice": "Message vocal (optionnel)",
    "uploadingEvidence": "Envoi des preuves ({{done}}/{{total}})…",
    "disputeTooShort": "Donnez un peu plus de détails (4 caractères minimum).",
    "evidenceFailed": "{{count}} pièce jointe n'a pas pu être téléversée.",
    "evidenceFailed_other": "{{count}} pièces jointes n'ont pas pu être téléversées."
  },
  "issueDetail": {
    "status": "Statut",
    "kind": "Type",
    "description": "Description",
    "aiSummary": "Analyse de l'IA",
    "filed": "Envoyé le",
    "location": "Emplacement",
    "openInMaps": "Ouvrir dans Google Maps",
    "category": "Catégorie",
    "address": "Adresse",
    "addressPending": "Géocodage inverse en cours…",
    "photoUnavailable": "Photo indisponible",
    "photoDot": "Photo {{index}}",
    "categoryPending": "En attente de triage",
    "timeline": "Progression",
    "transcript": "Transcription vocale",
    "voiceNote": "Note vocale",
    "voiceNoteFailed": "Impossible de charger le message vocal. Vérifiez votre connexion et réessayez.",
    "rejectedTitle": "Rejeté",
    "rejectedNoReason": "La ville a fermé ce signalement sans intervention.",
    "messages": {
      "title": "Messages",
      "empty": "Aucun message pour le moment. Des questions sur ce signalement ? Écrivez à la ville ici.",
      "placeholder": "Écrivez un message…",
      "send": "Envoyer",
      "staffBadge": "Équipe",
      "sendFailed": "Impossible d'envoyer votre message. Veuillez réessayer."
    }
  },
  "profile": {
    "title": "Profil",
    "name": {
      "label": "Votre nom",
      "placeholder": "Comment devons-nous vous appeler ?",
      "edit": "Modifier votre nom",
      "failed": "Impossible d'enregistrer votre nom.",
      "promptTitle": "Comment devons-nous vous appeler ?",
      "promptBody": "Vous vous êtes inscrit avec votre numéro de téléphone, nous n'avons donc pas encore votre nom.",
      "promptCta": "Ajouter votre nom"
    },
    "roles": "Rôles",
    "language": "Langue",
    "support": "Aide et assistance",
    "avatar": {
      "change": "Changer la photo",
      "remove": "Supprimer la photo",
      "failed": "Impossible de mettre à jour votre photo. Réessayez.",
      "tooLarge": "Photo trop volumineuse — choisissez-en une de moins de 5 Mo.",
      "unreadable": "Cette image n'a pas pu être lue. Essayez une autre photo, ou un JPEG ou un PNG."
    },
    "notifications": {
      "title": "Notifications",
      "statusUpdates": "Mises à jour des signalements",
      "announcements": "Communications de la ville",
      "updateFailed": "Impossible d'enregistrer votre préférence. Réessayez.",
      "enablePrompt": "Recevoir des notifications pour vos signalements",
      "enable": "Activer",
      "enableFailed": "Impossible d'activer les notifications",
      "blocked": "Les notifications sont bloquées dans les réglages de votre navigateur.",
      "unsupported": "Ce navigateur ne prend pas en charge les notifications.",
      "iosInstallRequired": "Sur iPhone, les notifications exigent que My City soit ajouté à votre écran d'accueil.",
      "iosInstallAction": "Voir comment faire",
      "iosOpenInSafari": "Ouvrez My City dans Safari pour l'ajouter à votre écran d'accueil — les notifications ne peuvent pas être activées depuis le navigateur intégré de cette application."
    },
    "role": {
      "citizen": "Citoyen·ne",
      "crew_member": "Membre d'équipe",
      "group_manager": "Gestionnaire de département",
      "supervisor": "Superviseur",
      "city_manager": "Gestionnaire municipal",
      "system_admin": "Administrateur système"
    },
    "stats": {
      "title": "Mon activité",
      "submitted": "Signalements envoyés",
      "resolved": "Signalements résolus",
      "citizenScore": "Score citoyen",
      "reopened": "Cas rouverts"
    },
    "city": {
      "label": "Ville",
      "hint": "Votre ville est détectée automatiquement — modifiez-la ici au besoin.",
      "unavailable": "Indisponible pour le moment"
    },
    "identity": {
      "title": "Méthodes de connexion",
      "subtitle": "Ajoutez celle que vous n’avez pas utilisée à l’inscription — si un autre compte existe déjà avec, les deux sont fusionnés et rien n’est perdu.",
      "phone": "Téléphone",
      "email": "Courriel",
      "add": "Ajouter",
      "phonePlaceholder": "+1 416 555 1234",
      "emailPlaceholder": "nom@exemple.com",
      "sendCode": "Envoyer le code",
      "codeSent": "Saisissez le code à 6 chiffres envoyé à {{target}}.",
      "codePlaceholder": "······",
      "verify": "Vérifier",
      "addedNote": "Ajouté — vous pouvez maintenant vous connecter des deux façons.",
      "mergedNote": "Vérifié — votre autre compte a été fusionné avec celui-ci. Tous ses signalements et messages sont ici.",
      "errors": {
        "invalidPhone": "Saisissez le numéro complet avec l’indicatif (ex. +1…).",
        "invalidEmail": "Saisissez une adresse courriel valide.",
        "emailUnavailable": "La vérification par courriel n’est pas encore disponible — réessayez quand le service courriel sera activé.",
        "tooManySends": "Trop de tentatives — patientez une minute puis réessayez.",
        "alreadyYours": "Cet identifiant est déjà sur votre compte.",
        "invalidCode": "Code erroné ou expiré.",
        "conflict": "Cet identifiant ne peut pas être ajouté à ce compte.",
        "sendFailed": "Impossible d’envoyer le code. Réessayez.",
        "verifyFailed": "Échec de la vérification. Réessayez.",
        "slotOccupied": "Votre compte en possède déjà un — contactez le support pour le modifier.",
        "needsOperator": "L’autre compte a un accès personnel dans une autre ville. Demandez à un administrateur de les fusionner."
      }
    }
  },
  "announcements": {
    "title": "Communications de la ville",
    "kind": {
      "news": "Actualité",
      "announcement": "Avis",
      "event": "Événement"
    },
    "empty": "Votre ville n'a rien publié pour le moment. Revenez bientôt.",
    "learnMore": "En savoir plus",
    "imageDot": "Aller à l'image {{index}}",
    "category": {
      "emergency": "Urgence",
      "road_work": "Travaux routiers",
      "event": "Événement",
      "project_update": "Mise à jour du projet",
      "notice": "Avis public",
      "general": "Général"
    },
    "addToCalendar": "Ajouter au calendrier",
    "comments": {
      "title": "Commentaires",
      "placeholder": "Ajouter un commentaire…",
      "send": "Publier le commentaire",
      "failed": "Impossible de publier votre commentaire. Réessayez.",
      "empty": "Aucun commentaire pour le moment. Soyez le premier à réagir.",
      "staffBadge": "Équipe",
      "anonymous": "Anonyme",
      "delete": "Supprimer le commentaire",
      "deleteConfirm": "Supprimer ce commentaire ? Cette action est irréversible."
    }
  },
  "projectDetail": {
    "title": "Projet municipal",
    "completion": "Avancement",
    "startDate": "Début",
    "endDate": "Fin prévue"
  },
  "common": {
    "loading": "Chargement...",
    "error": "Une erreur s'est produite",
    "retry": "Réessayer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "back": "Retour",
    "dismiss": "Ignorer",
    "charCount": "{{used}}/{{max}}",
    "loadMore": "Charger plus"
  },
  "locale": {
    "name": "Langue",
    "en": "English",
    "fr": "Français",
    "qaRtl": "QA (RTL stub)"
  },
  "map": {
    "title": "Carte de la ville",
    "layersLabel": "Couches de la carte",
    "layers": {
      "issues": "Signalements",
      "projects": "Projets",
      "eventsAnnouncements": "Événements et avis",
      "news": "Actualités"
    },
    "viewDetails": "Voir les détails",
    "cluster": "Regroupement",
    "heat": "Carte de chaleur",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "locate": "Trouver ma position",
    "locateDenied": "L'accès à votre position est bloqué — autorisez-le dans les réglages de votre navigateur pour l'utiliser.",
    "locateUnavailable": "Votre position est indisponible pour le moment. Réessayez plus tard.",
    "projectCompletion": "{{pct}} % terminé",
    "unavailable": "Ce navigateur ne peut pas afficher la carte. L’adresse et les coordonnées sont indiquées ci-dessus."
  },
  "theme": {
    "label": "Thème",
    "light": "Clair",
    "system": "Système",
    "dark": "Sombre"
  },
  "ios": {
    "installTitle": "Installer My City",
    "installBody": "Appuyez sur le bouton de partage ci-dessous, puis « Sur l’écran d’accueil » pour installer. Permet à l’application de recevoir des notifications sur vos signalements."
  },
  "nav": {
    "home": "Accueil",
    "map": "Carte",
    "reports": "Signalements",
    "profile": "Profil",
    "reportIssue": "Nouveau signalement ou demande"
  },
  "issueCategory": {
    "infrastructure": "Infrastructures",
    "green_space": "Espaces verts",
    "sanitation": "Salubrité",
    "safety_traffic": "Sécurité et circulation",
    "equipment": "Équipements",
    "other": "Autre"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "Vous êtes à jour.",
    "markAllRead": "Tout marquer comme lu",
    "updateFailed": "Impossible de marquer comme lu. Vérifiez votre connexion et réessayez.",
    "events": {
      "work_order_assigned": {
        "problem": "Votre signalement a été assigné",
        "request": "Votre demande a été assignée"
      },
      "work_order_in_progress": {
        "problem": "Les travaux ont commencé pour votre signalement",
        "request": "Le traitement de votre demande a commencé"
      },
      "work_order_resolved": {
        "problem": "Votre signalement a été résolu",
        "request": "Votre demande a été traitée"
      },
      "work_order_closed": {
        "problem": "Votre signalement a été fermé",
        "request": "Votre demande a été fermée"
      },
      "work_order_reopened": {
        "problem": "Votre signalement a été rouvert",
        "request": "Votre demande a été rouverte"
      },
      "work_order_cancelled": {
        "problem": "Votre signalement a été refusé",
        "request": "Votre demande a été refusée"
      },
      "issue_message": "Nouveau message sur votre signalement",
      "issue_message_coded": "Nouveau message sur votre signalement {{code}}",
      "support_reply": "L’assistance a répondu à votre demande",
      "issue_created": {
        "problem": "Nouveau signalement reçu",
        "request": "Nouvelle demande reçue"
      },
      "validation_reopened": "Signalement rouvert",
      "validation_closed": "Réparation confirmée par le citoyen",
      "support_ticket_opened": "Nouvelle demande d’assistance",
      "support_ticket_reply": "Un citoyen a répondu à une demande d’assistance"
    }
  },
  "projectStatus": {
    "planned": "Planifié",
    "in_progress": "En cours",
    "completed": "Terminé"
  },
  "support": {
    "title": "Assistance",
    "new": "Nouvelle demande",
    "newTitle": "Nouvelle demande d'assistance",
    "subject": "Sujet",
    "message": "Message",
    "submit": "Envoyer",
    "empty": "Vous n'avez pas encore contacté l'assistance.",
    "status": {
      "open": "Ouverte",
      "answered": "Répondue",
      "closed": "Fermée"
    },
    "close": "Fermer la demande",
    "closeConfirm": "Fermer cette demande ? Vous pourrez toujours la consulter, mais plus y répondre.",
    "closedNote": "Cette demande est fermée.",
    "messagePlaceholder": "Écrivez un message…",
    "send": "Envoyer",
    "staffBadge": "Équipe",
    "errors": {
      "createFailed": "Impossible de créer la demande. Réessayez dans un instant."
    },
    "sendFailed": "Impossible d'envoyer votre message. Veuillez réessayer.",
    "closeFailed": "Impossible de fermer le billet. Veuillez réessayer."
  },
  "announcementDetail": {
    "when": "Quand",
    "addToCalendar": "Ajouter au calendrier"
  },
  "dates": {
    "today": "Aujourd'hui",
    "yesterday": "Hier"
  },
  "reportDetail": {
    "alreadyReported": "Quelqu’un l’avait déjà signalé sous {{code}}. Votre signalement est rattaché à la même intervention : le statut affiché ici est donc le bon."
  }
}
